import { render, staticRenderFns } from "./repaymentPlan.vue?vue&type=template&id=4ba583c9&scoped=true"
import script from "./repaymentPlan.vue?vue&type=script&lang=js"
export * from "./repaymentPlan.vue?vue&type=script&lang=js"
import style0 from "./repaymentPlan.vue?vue&type=style&index=0&id=4ba583c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba583c9",
  null
  
)

export default component.exports